var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "point-label",
        {
          staticClass: "mb16",
          attrs: {
            name: _vm.$t("pc_biz_lbl_task_model").d("任务模型"),
            type: _vm.type,
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.rtDetails.modelName))])]
      ),
      _c("yxt-tree", {
        ref: "rtModelDetailTree",
        attrs: {
          data: _vm.rtDetails.rtList,
          props: _vm.props,
          "show-checkbox": "",
          "node-key": "rtId",
          "wrap-width": "100%",
          "default-expand-all": "",
          "default-checked-keys": _vm.defaultCheckedKeys,
        },
        on: { "check-change": _vm.changeCheck },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var data = ref.data
              return _c(
                "span",
                {},
                [
                  _c(
                    "yxt-popover",
                    {
                      attrs: {
                        disabled: !data.taskDesc,
                        "max-width": 500,
                        placement: "bottom",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "\n          " + _vm._s(data.taskDesc) + "\n        "
                        ),
                      ]),
                      _c(
                        "span",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          _vm._v(
                            "\n          " + _vm._s(data.name) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }